var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3274C0",
    fillRule: "evenodd",
    d: "M6 7.395c.01 2.63.032 7.077 1.06 8.41c1.111 1.44 2.675 2.302 3.744 2.892c.352.194.65.359.861.505a.48.48 0 0 0 .527.01c.296-.205.72-.442 1.195-.708c1.232-.69 2.815-1.577 3.436-2.609c.928-1.541 1.11-5.758 1.177-8.459a.503.503 0 0 0-.512-.507c-2.228.012-4.187-.815-5.16-1.64a.6.6 0 0 0-.758-.02C9.928 6.622 7.93 6.868 6.48 6.905a.49.49 0 0 0-.48.49m1.5.927c.01 1.862.189 5.824.823 6.781c.507.766 1.716 1.386 2.614 1.846c.505.259.911.467 1.04.623c.203-.19.627-.418 1.123-.684c.881-.473 1.99-1.068 2.48-1.785c.556-.812.878-4.834.92-6.781c-2.065.133-3.876-.92-4.523-1.465c-1.309 1.1-3.53 1.435-4.477 1.465",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwt);
export default __webpack_public_path__ + "static/media/twt.e75f6698579438c1c6554d0b31f80405.svg";
export { ForwardRef as ReactComponent };